/* eslint-disable react/function-component-definition */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { TableContext } from '../../contexts/tableContext';
import useToggle from '../../hooks/useToggle';
import { getCookies } from '../../hooks/useCookies';
import ToggleButtonOnOff from '../ToggleButton/ToggleButton';
import TableViewPopup from '../TableViewPopup/TableViewPopup';
import styles from './AgGridTable.module.scss';
import { Entry } from '../../redux/entrySlice';
import 'react-confirm-alert/src/react-confirm-alert.css';
import searchImg from '../../assets/search.svg';
import DeleteModal from '../DeleteModal/DeleteModal';

// const CryptoJS = require('crypto-js');
const AgGridTable = React.memo(
  ({
    urlParam,
    fieldNames,
    section,
    viewPopUp,
    toggleButton,
    addButtonPlaceholder,
    deleteCondition,
    showAdd,
    sectionTitle,
    searchPlaceholder,
  }) => {
    // eslint-disable-next-line max-len
    const { bodyheader, url, actionbtnStyle } = useContext(TableContext);
    const [actionPermissions, setActionPermission] = useState({});
    const { searchboxStyle } = useContext(TableContext);
    const { addBtnStyle } = useContext(TableContext);
    const token = `Bearer ${getCookies('Token')}`;
    const [deleteMessage, setDeletemessage] = useState(null);
    const [canDelete, setCanDelete] = useState(true);
    let statusCode;
    let rowStyle;
    const navigate = useNavigate();
    const overlayNoRowsTemplate = 'No record found';
    const dispatch = useDispatch();
    const [isOpen, setisOpen] = useToggle();
    const [showTablePopUp, setShowTablePopUp] = useToggle();
    const [dataId, setDataId] = useState();
    const [gridApi, setGridApi] = useState(null);
    const [search, setSearchTerm] = useState(null);
    const [deletedUser, setDeletedUser] = useState(null);
    const perPage = 5;
    const [showDeleteModal, setDeleteModal] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState();

    const onGridReady = (params) => {
      const gApi = params.api;
      setGridApi(params.api);
      if (gApi) {
        gApi.sizeColumnsToFit();
        const dataSource = {
          getRows: (params) => {
            const { filterModel, sortModel } = params;
            let urls = urlParam;
            // Use startRow and endRow for sending pagination to Backend
            // params.startRow : Start Page
            // params.endRow : End Page
            gApi.showLoadingOverlay();
            const page = params.endRow / perPage;
            urls += `page=${page}&limit=${perPage}`;
            // Sorting
            if (sortModel.length) {
              const { colId, sort } = params.sortModel[0];
              urls += `&sortBy=${colId}:${sort}`;
            }
            // Searching
            if (search !== null && search.length > 0) {
              urls += `&searchBy=${search}`;
            }
            fetch(urls, {
              method: 'GET',
              headers: { Authorization: token },
            })
              .then((resp) => {
                statusCode = resp.status;
                return resp.json();
              })
              .then((res) => {
                if (statusCode === 200 && res.data.result.totalResults > 0) {
                  gApi.hideOverlay();
                  params.successCallback(res.data.result.results, res.data.result.totalResults);
                } else {
                  gApi.showNoRowsOverlay();
                  params.successCallback([], 0);
                }
              })
              .catch((err) => {
                gApi.showNoRowsOverlay();
                params.successCallback([], 0);
              });
          },
        };

        gApi.setDatasource(dataSource);
      }
    };

    const actionView = (params) => {
      const encodeText = params.data.id;
      setDataId(params.data.id);
      if (viewPopUp) {
        setShowTablePopUp();
      } else {
        navigate(`/${section}/viewdetails/${encodeText}`);
      }
    };

    const actionEdit = (params) => {
      const encodeText = params.data.id;
      navigate(`/${section}/edit/${encodeText}`);
    };

    const actionAdd = () => {
      navigate(`/${section}/create/`);
    };

    let checked = 'true';
    const handleChange = () => {
      [checked] = ![checked];
    };

    const confirmDelete = () => {
      const actionData = {
        actionUrl: `${section}/${deleteItemId}`,
        actionMethod: 'delete',
      };
      dispatch(Entry(actionData)).then((resp) => {
        if (resp.payload.code === 400) {
          const { message } = resp.payload;
          if (message) {
            toast.error(message);
          } else {
            toast.error('Failed to delete');
          }
          // console.log(resp.payload.message, 'Failed to delete');
        } else {
          toast.success(`${sectionTitle} deleted successfully`);
          setDeletedUser(`data last deleted is ${deleteItemId}`);
          setDeleteModal(false);
        }
      });
    };

    const handleDelete = (params) => {
      setDeleteItemId(params.data.id);
      setDeleteModal(true);
    };

    const handleDeleteClose = () => setDeleteModal(false);

    const avatarFormatter = ({ value }) => (
      <img src={value} alt="img s" width="50px" height="50px" />
    );

    const toggleButtons = (params) => {
      if (params?.data) {
        return (
          <ToggleButtonOnOff
            value={params.value}
            id={params.data ? params.data.id : null}
            placeholders={['Active', 'Inactive']}
            onMessage={toggleButton.onMessage}
            offMessage={toggleButton.offMessage}
          />
        );
      }
      return null;
    };

    const actions = (params) => {
      if (params?.data) {
        return (
          <div>
            {actionPermissions.view && (
              <button
                className={styles[actionbtnStyle]}
                id={styles.actionbtn}
                type="button"
                onClick={() => {
                  actionView(params);
                }}
              >
                {' '}
                <i className="fa fa-eye" />
                {/* <svg
              width="20"
              height="14"
              viewBox="0 0 20 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.8729 6.61109C19.6942 6.36667 15.4371 0.626465 9.9999 0.626465C4.56274 0.626465 0.305391 6.36667 0.126914 6.61085C-0.0423048 6.84273 -0.0423048 7.15722 0.126914 7.3891C0.305391 7.63351 4.56274 13.3737 9.9999 13.3737C15.4371 13.3737 19.6942 7.63347 19.8729 7.38929C20.0423 7.15746 20.0423 6.84273 19.8729 6.61109ZM9.9999 12.055C5.99486 12.055 2.52606 8.24515 1.49922 6.99964C2.52473 5.75304 5.98626 1.94514 9.9999 1.94514C14.0048 1.94514 17.4733 5.75437 18.5006 7.00054C17.4751 8.24711 14.0135 12.055 9.9999 12.055Z"
                fill="#98999E"
              />
              <path
                d="M10 3.04395C7.81868 3.04395 6.04395 4.81868 6.04395 7.00001C6.04395 9.18134 7.81868 10.9561 10 10.9561C12.1813 10.9561 13.9561 9.18134 13.9561 7.00001C13.9561 4.81868 12.1813 3.04395 10 3.04395ZM10 9.63736C8.54571 9.63736 7.36266 8.45427 7.36266 7.00001C7.36266 5.54575 8.54575 4.36266 10 4.36266C11.4543 4.36266 12.6374 5.54575 12.6374 7.00001C12.6374 8.45427 11.4543 9.63736 10 9.63736Z"
                fill="#98999E"
              />
            </svg> */}
              </button>
            )}
            {actionPermissions.edit && (
              <button
                className={styles[actionbtnStyle]}
                id={styles.actionbtn}
                type="button"
                onClick={() => {
                  actionEdit(params);
                }}
              >
                {' '}
                <i className="fa fa-edit" />
                {/* <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_207_498)">
                <path
                  d="M19.4537 10.4057C19.0654 10.4057 18.7506 10.7205 18.7506 11.1089V21.4217C18.7506 22.0679 18.2249 22.5936 17.5787 22.5936H2.57821C1.93201 22.5936 1.40629 22.0679 1.40629 21.4217V6.42122C1.40629 5.77503 1.93201 5.24931 2.57821 5.24931H12.891C13.2794 5.24931 13.5942 4.93449 13.5942 4.54616C13.5942 4.15784 13.2794 3.84302 12.891 3.84302H2.57821C1.15658 3.84302 0 4.9996 0 6.42122V21.4217C0 22.8433 1.15658 23.9999 2.57821 23.9999H17.5787C19.0003 23.9999 20.1569 22.8433 20.1569 21.4217V11.1089C20.1569 10.7205 19.8421 10.4057 19.4537 10.4057Z"
                  fill="#98999E"
                />
                <path
                  d="M23.5204 1.80566L22.1945 0.479757C21.5549 -0.159919 20.514 -0.159919 19.8743 0.479757L9.2674 11.0867C9.16924 11.1848 9.10235 11.3099 9.07507 11.446L8.41209 14.7607C8.36601 14.9912 8.43815 15.2295 8.60443 15.3958C8.7376 15.5289 8.917 15.6017 9.1016 15.6017C9.14749 15.6017 9.19362 15.5972 9.23946 15.5881L12.5541 14.9251C12.6903 14.8979 12.8153 14.8309 12.9135 14.7328L23.5204 4.1259C24.16 3.48627 24.1601 2.44538 23.5204 1.80566ZM12.0696 13.5879L9.99797 14.0023L10.4124 11.9306L19.0456 3.29722L20.703 4.95458L12.0696 13.5879ZM22.526 3.13151L21.6974 3.96019L20.04 2.30283L20.8686 1.47419C20.96 1.38279 21.1087 1.38274 21.2001 1.47415L22.526 2.80005C22.6174 2.89141 22.6174 3.04015 22.526 3.13151Z"
                  fill="#98999E"
                />
              </g>
              <defs>
                <clipPath id="clip0_207_498">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg> */}
              </button>
            )}
            {actionPermissions.delete && (
              <button
                className={styles[actionbtnStyle]}
                id={styles.actionbtn}
                type="button"
                onClick={() => {
                  handleDelete(params);
                }}
              >
                {' '}
                <i className="fa fa-trash" />
              </button>
            )}
          </div>
        );
      }
      return null;
    };

    const columns = useMemo(() => {
      const columnsArray = [];
      let agheaderclass;
      if (fieldNames.length) {
        fieldNames.forEach((element) => {
          if (element.db === toggleButton.field) {
            if (localStorage.getItem('theme') === 'dark') {
              agheaderclass = styles.headercolordark;
            } else {
              agheaderclass = styles.headercolorlight;
            }
            columnsArray.push({
              headerName: element.view.toUpperCase(),
              field: element.db.toLowerCase(),
              headerClass: agheaderclass,
              cellRenderer: toggleButtons,
            });
          } else {
            if (localStorage.getItem('theme') === 'dark') {
              agheaderclass = styles.headercolordark;
            } else {
              agheaderclass = styles.headercolorlight;
            }
            columnsArray.push({
              headerName: element.view.toUpperCase(),
              headerClass: agheaderclass,
              field: element.db.toLowerCase(),
            });
          }
        });

        columnsArray.push({
          headerName: 'ACTIONS',
          field: 'email',
          cellRenderer: actions,
          headerClass: agheaderclass,
          sortable: false,
        });
      }
      return columnsArray;
    }, [actionPermissions]);

    useEffect(() => {
      const temp = section.replace(/\s+/g, '').toLowerCase();
      const permissions = getCookies('USERPERMISSION');
      // Handle undefined permissions (for admin users who don't have USERPERMISSION)
      if (!permissions || !Array.isArray(permissions)) {
        // For admin users, allow all permissions by default
        setActionPermission({
          view: true,
          edit: true,
          create: true,
          delete: true,
          list: true,
        });
        return;
      }
      permissions.forEach((val) => {
        if (val.section.toLowerCase() === temp) {
          setActionPermission({
            view: val.view ? val.view : false,
            edit: val.edit ? val.edit : false,
            create: val.create ? val.create : false,
            delete: val.delete ? val.delete : false,
            list: !!(val.view || val.edit || val.create || val.delete),
          });
        } else if (val.submenu) {
          val.submenu.forEach((element) => {
            if (element.section.toLowerCase() === temp) {
              setActionPermission({
                view: element.view ? element.view : false,
                edit: element.edit ? element.edit : false,
                create: element.create ? element.create : false,
                delete: element.delete ? element.delete : false,
                list: !!(element.view || element.edit || element.create || element.delete),
              });
            }
          });
        }
      });
      if (deleteCondition.checkCondition) {
        setCanDelete(false);
        setDeletemessage('Sorry you cant delete this data');
      }
      if (gridApi) {
        gridApi.sizeColumnsToFit();
        const dataSource = {
          getRows: (params) => {
            const { filterModel, sortModel } = params;
            let urls = urlParam;
            // Use startRow and endRow for sending pagination to Backend
            // params.startRow : Start Page
            // params.endRow : End Page
            gridApi.showLoadingOverlay();
            const page = params.endRow / perPage;
            urls += `page=${page}&limit=${perPage}`;
            // Sorting
            if (sortModel.length) {
              const { colId, sort } = params.sortModel[0];
              urls += `&sortBy=${colId}:${sort}`;
            }
            // Searching
            if (search !== null && search.length > 0) {
              urls += `&searchBy=${search}`;
            }
            fetch(urls, {
              method: 'GET',
              headers: { Authorization: token },
            })
              .then((resp) => {
                statusCode = resp.status;
                return resp.json();
              })
              .then((res) => {
                if (statusCode === 200 && res.data.result.totalResults > 0) {
                  gridApi.hideOverlay();
                  params.successCallback(res.data.result.results, res.data.result.totalResults);
                } else {
                  gridApi.showNoRowsOverlay();
                  params.successCallback([], 0);
                }
              })
              .catch((err) => {
                gridApi.showNoRowsOverlay();
                params.successCallback([], 0);
              });
          },
        };

        gridApi.setDatasource(dataSource);
      }
    }, [search, deletedUser, url]);

    const onFilterTextChange = (e) => {
      gridApi.setQuickFilter(e.target.value);
      setSearchTerm(e.target.value);
    };

    if (localStorage.getItem('theme') === 'dark') {
      rowStyle = {
        background: '#2b2b40',
        height: '50px',
        borderBottomStyle: 'none',
        borderRadius: '10px',
        paddingTop: '4px',
        color: '#818896',
        textOverflow: 'initial',
      };
    } else if (localStorage.getItem('theme') === 'light') {
      rowStyle = {
        background: '#fff !important',
        height: '50px',
        borderBottomStyle: 'none',
        borderRadius: '10px',
        paddingTop: '4px',
        textOverflow: 'initial',
      };
    }

    return (
      <div>
        {actionPermissions.list && (
          <div>
            <div className="table_top">
              <div className="search_contain mr-1 mb-20">
                <Image src={searchImg} alt="search" />
                <input
                  className={`${styles[searchboxStyle]} searchbar`}
                  id={styles.searchbar}
                  type="search"
                  onChange={onFilterTextChange}
                  placeholder={searchPlaceholder}
                />
              </div>
              <div id={styles.searchboxpad}>
                {/* <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.sidemenuicon} /> */}
                <div className={styles.sectionright}>
                  {actionPermissions.create && showAdd && (
                    <button
                      className={`${styles[addBtnStyle]} addBtn mb-20`}
                      type="button"
                      onClick={() => {
                        actionAdd();
                      }}
                    >
                      {' '}
                      <FontAwesomeIcon icon={faPlus} className="add_icon" />
                      Add New {addButtonPlaceholder}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="ag-theme-alpine" style={{ height: '400px' }}>
              <AgGridReact
                rowStyle={rowStyle}
                pagination
                rowSelection="multiple"
                columnDefs={columns}
                rowModelType="infinite"
                paginationPageSize={perPage}
                cacheBlockSize={perPage}
                onGridReady={onGridReady}
                rowHeight={60}
                overlayNoRowsTemplate={overlayNoRowsTemplate}
                defaultColDef={{
                  sortable: true,
                  // headerCheckboxSelection: true,
                  // checkboxSelection: true,
                }}
                suppressDragLeaveHidesColumns
              />
            </div>
            {showTablePopUp ? (
              <TableViewPopup dataId={dataId} handleClose={setShowTablePopUp} section={section} />
            ) : null}
          </div>
        )}
        <DeleteModal
          show={showDeleteModal}
          context={sectionTitle}
          handleClose={handleDeleteClose}
          onConfirm={confirmDelete}
          onCancel={handleDeleteClose}
        />
      </div>
    );
  }
);

AgGridTable.propTypes = {
  urlParam: PropTypes.string.isRequired,
  fieldNames: PropTypes.oneOfType([PropTypes.array]).isRequired,
  section: PropTypes.string.isRequired,
  viewPopUp: PropTypes.bool,
  toggleButton: PropTypes.oneOfType([PropTypes.object]),
  addButtonPlaceholder: PropTypes.string,
  deleteCondition: PropTypes.oneOfType([PropTypes.any]),
  showAdd: PropTypes.bool,
  sectionTitle: PropTypes.string,
  searchPlaceholder: PropTypes.string,
};

AgGridTable.defaultProps = {
  viewPopUp: false,
  toggleButton: { show: false, field: 'none' },
  addButtonPlaceholder: '',
  deleteCondition: { checkCondition: false, apiUrl: 'none' },
  showAdd: true,
  sectionTitle: 'Row',
  searchPlaceholder: 'Search',
};

export default AgGridTable;
